import React from 'react';

interface CardProps {
    children: React.ReactNode;
    className?: string;
    /** Elevated cards have a slightly brighter background */
    elevated?: boolean;
    /** Hoverable cards lift on hover with a subtle shadow */
    hoverable?: boolean;
    /** Optional click handler — makes the card interactive */
    onClick?: () => void;
}

export function Card({
    children,
    className = '',
    elevated = false,
    hoverable = false,
    onClick,
}: CardProps) {
    const Tag = onClick ? 'button' : 'div';
    return (
        <Tag
            onClick={onClick}
            className={`
        rounded-xl border transition-colors duration-200
        ${elevated
                    ? 'bg-bg-elevated border-border-default'
                    : 'bg-bg-surface border-border-subtle'
                }
        ${hoverable
                    ? 'hover:-translate-y-0.5 hover:shadow-lg hover:shadow-zinc-950/20 hover:border-border-strong cursor-pointer'
                    : ''
                }
        ${onClick ? 'text-left w-full focus-visible:ring-2 focus-visible:ring-zinc-500/50 focus-visible:outline-none' : ''}
        ${className}
      `}
        >
            {children}
        </Tag>
    );
}

interface CardHeaderProps {
    children: React.ReactNode;
    className?: string;
}

export function CardHeader({ children, className = '' }: CardHeaderProps) {
    return (
        <div className={`px-5 py-4 border-b border-border-subtle ${className}`}>
            {children}
        </div>
    );
}

interface CardContentProps {
    children: React.ReactNode;
    className?: string;
}

export function CardContent({ children, className = '' }: CardContentProps) {
    return <div className={`px-5 py-4 ${className}`}>{children}</div>;
}
